import React, { MutableRefObject } from "react";
import scrollButtonStyles from './AlmeScrollButton.styles';
import { Button } from "@material-ui/core";
import { WithStyles, withStyles } from '@material-ui/core/styles';
import { FocusComponentProps } from "../../models/ComponentProps";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { AlmeScrollButtonConfig } from "./AlmeScrollButtonConfig";
import { FormattedMessage } from "react-intl";
import { useFocusStyles } from "../FocusVisibleStyle";

interface AlmeScrollButtonProps extends WithStyles<typeof scrollButtonStyles> {
    scrollToResponse: MutableRefObject<boolean>;
    almeConfig: AlmeScrollButtonConfig;
    focusProps?: FocusComponentProps;
    onScrollClick: () => void;
}

const AlmeScrollButton: React.FC<AlmeScrollButtonProps> | null = (props: AlmeScrollButtonProps) => {
    const Focusclasses = useFocusStyles();
    const handleClick = (): void => {
        props.scrollToResponse.current = true;
        props.onScrollClick();
    };

    return (
        <Button
            id='alme-scroll-button'
            className={`${props.classes.root} ${Focusclasses.visibleFocus}`}
            color={props.almeConfig.scrollButton.styles.color}
            variant={props.almeConfig.scrollButton.styles.variant}
            onClick={handleClick}
            {...props.focusProps}
        >
            <ArrowDownwardIcon />
            <FormattedMessage
                id="scrollButton.text"
                defaultMessage="Default scroll button text"
                description="Scroll Button text element" />
        </Button>
    );
};
export default withStyles(scrollButtonStyles)(AlmeScrollButton);
